import { Button } from '@platform/components';
import { useEffect, useState } from 'react';
import LinkedInLogo from './LinkedIn_icon.svg';

export const LinkedInSignInButton = () => {
  const [loginTarget, setLoginTarget] = useState('http://localhost:8000/api/login/linkedin');

  useEffect(() => {
    setLoginTarget(
      window && window.location.hostname !== 'localhost' ?
        import.meta.env.VITE_API_HOST + '/login/linkedin'
      : 'http://localhost:8000/api/login/linkedin',
    );
  }, []);

  return (
    <Button href={loginTarget} variant='secondary-gray' size='lg' additionalClassnames='w-full'>
      <img src={LinkedInLogo} height='24' width='24' /> {'Log in with LinkedIn'}
    </Button>
  );
};
